import axios from "axios";
import Const from "./Const";
import Utils from "./Utils";

let instance = axios.create({});
// instance.defaults.headers.token = Const.token;
instance.defaults.headers.token = sessionStorage.getItem("token");
instance.defaults.baseURL = Const.RemotePath;

export default class Request {
  /** post请求 */
  public static async Get(url, param?) {
    instance.defaults.headers.token = sessionStorage.getItem("token");
    return new Promise((reslove, reject) => {
      instance
        .get(`${url}`, { params: param })
        .then((res) => {
          if (res.data?.code == 0) {
            reslove(res.data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public static async jsonPost(url: string, params: any) {
    try {
      // let res = await axios.post(`${Const.RemotePath}${url}`, params, {
      let res = await axios.post(`${url}`, params, {
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });
      return res.data;
    } catch (err: any) {
      return { success: false, message: err.message };
    }
  }

  /** post请求 */
  public static async Post(url, param) {
    return new Promise((reslove, reject) => {
      instance
        .post(url, Utils.recordToForm(param))
        .then((res) => {
          reslove(res.data);
          return res.data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }

  /** delete请求 */
  public static async Delete(url, param) {
    return new Promise((reslove, reject) => {
      instance
        .delete(url, param)
        .then((res) => {
          reslove(res.data);
          return res.data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
}
